import { FC } from 'react';
import classNames from 'classnames';

import styles from './index.module.less';

interface BuildInButtonProps extends I_BaseComponentProps {
	light?: boolean;
}

export const BuildInButton: FC<BuildInButtonProps & React.HTMLAttributes<HTMLElement>> = (
	props,
) => {
	const { children, className, style, light, ...rest } = props;

	return (
		<div
			className={classNames(styles.build_in_button, className, { [styles.light]: light })}
			style={style}
			{...rest}
		>
			{children}
		</div>
	);
};
